module.exports = __webpack_public_path__ + "img/bed-256.7b5e58ad.jpg";